module.exports = __webpack_public_path__ + "static/media/home-hero@2x.9827050d.png";